
import { format, addDays, startOfMonth, endOfMonth, startOfWeek, endOfWeek, isSameMonth, isSameDay } from "date-fns";
import { CalendarDay, CalendarRange } from './types';

export const calculateCalendarRange = (currentMonth: Date): CalendarRange => {
  const monthStart = startOfMonth(currentMonth);
  const monthEnd = endOfMonth(currentMonth);
  const calendarStart = startOfWeek(monthStart, { weekStartsOn: 0 });
  const calendarEnd = endOfWeek(monthEnd, { weekStartsOn: 0 });
  
  return { calendarStart, calendarEnd, monthStart };
};

export const generateCalendarDays = (
  calendarRange: CalendarRange,
  selectedDate: Date | undefined,
  getDayColor: (dateStr: string) => string,
  getDayTooltip: (dateStr: string) => string,
  getScheduleForDate: (dateStr: string) => any
): CalendarDay[] => {
  const { calendarStart, calendarEnd, monthStart } = calendarRange;
  const days: CalendarDay[] = [];
  let day = calendarStart;

  while (day <= calendarEnd) {
    const currentDay = new Date(day);
    const dateStr = format(currentDay, 'yyyy-MM-dd');
    const isCurrentMonth = isSameMonth(currentDay, monthStart);
    const isSelected = selectedDate && isSameDay(currentDay, selectedDate);
    const isToday = isSameDay(currentDay, new Date());
    const isPast = currentDay < new Date(new Date().toDateString());

    days.push({
      date: currentDay,
      dateStr,
      isCurrentMonth,
      isSelected,
      isToday,
      isPast,
      dayColorClass: getDayColor(dateStr),
      tooltip: getDayTooltip(dateStr),
      schedule: getScheduleForDate(dateStr)
    });

    day = addDays(day, 1);
  }

  return days;
};
